export default __webpack_public_path__ + "static/media/about-rocket-icon.1ad3b66a.svg";